import { Controller } from "@hotwired/stimulus"

// Mobile-only: the filter modal is one form rendered as two stacked screens —
// "search" (query + content-type/style chips) and "filters" (channel,
// collection, sort). Desktop shows both at once in the sidebar, so the toggle
// buttons are md:hidden there and this state attribute is inert (CSS only acts
// on it below the md breakpoint).
//
// The screen state lives on THIS element's data-screen attribute. Crucially,
// the index.turbo_stream response only swaps leaf regions *inside* it
// (#search_results, #genre_filters, …) and never this container — so a live
// keystroke or chip tap re-renders results and facets without bouncing the user
// off the screen they're on. (Putting the toggle on a replaced region would
// reset the view on every keystroke — the main regression to guard against.)
//
// On open, modal_filters_controller resets us to "search"; on cancel it
// restores the snapshot HTML, which carries data-screen="search" with it. So
// "Cancel" returns to Screen A in the same operation that reverts the filters.
export default class extends Controller {
  showFilters() {
    this.element.dataset.screen = "filters"
  }

  showSearch() {
    this.element.dataset.screen = "search"
  }
}
